// ============================================================
// GWAP The Charts — MOCK DATA & BROWSER-ONLY HELPERS
// Replace BRAND contact details with your own information.
// Payments + accounts are MOCKED (localStorage) until backend/Stripe is wired.
// ============================================================

export const BRAND = {
  name: "GWAP",
  accent: "The Charts",
  full: "GWAP The Charts",
  email: "BigBoss@demgbiz.org",
};

export const HERO = {
  eye: "AI Scanner — 2+ Signals Every Day",
  line1: "Never Miss A Good Trade.",
  line2: "Never Take A Bad One.",
  sub: `${"GWAP The Charts"} scans the market in real time and tells you exactly when to buy or sell — with entry, stop loss, and profit target already calculated for you.`,
  proof: [
    { val: "2+", lbl: "Signals Daily" },
    { val: "31", lbl: "Markets Scanned" },
    { val: "15m", lbl: "Scan Interval" },
    { val: "TP1/TP2", lbl: "Every Signal" },
  ],
};

export const PLANS = [
  {
    id: "trial",
    badge: "Try It",
    badgeTone: "red",
    name: "3-Day Trial",
    price: 5,
    per: "3 days full access · one time",
    features: [
      "Full AI Scanner for 72 hours",
      "2+ AI-reviewed signals every day",
      "Entry, stop loss, TP1 & TP2 on every signal",
      "Upgrade anytime — no lock-in",
    ],
    cta: "Start Trial — $5",
    btn: "outline",
    days: 3,
  },
  {
    id: "monthly",
    badge: "Full Access",
    badgeTone: "gold",
    name: "Monthly",
    price: 79,
    per: "Per month · cancel anytime",
    features: [
      "AI Scanner — 28 forex pairs, Gold, BTC & ETH",
      "At least 2 signals a day with confidence score",
      "Email + Telegram signal alerts",
      "Live indicator, all markets & timeframes",
    ],
    cta: "Get Monthly — $79/mo",
    btn: "solid",
    featured: true,
    days: 30,
  },
];

export const STEPS = [
  { t: "The AI scans 31 markets", d: "Every 15 minutes the scanner checks all 28 forex pairs plus Gold, BTC and ETH on the 1-hour chart for an Impulse → Correction → Continuation pattern, confirmed by EMA trend, MACD momentum, RSI and volume." },
  { t: "Claude reviews every setup", d: "Each candidate is reviewed by AI. Only one signal runs at a time, so you can focus on a single pair, with at least 2 signals a day." },
  { t: "You get the full plan", d: "Entry, a stop beyond the correction, TP1 at the impulse high or low, TP2 at the impulse projected forward, plus a short AI explanation, land in your dashboard, inbox and Telegram." },
  { t: "Execute with confidence", d: "Only take the trade if it matches your own strategy and risk. The scanner gives you conviction — you make the final call." },
];
export const MARKETS = [
  { sym: "NQ", name: "Nasdaq 100 Futures" },
  { sym: "ES", name: "S&P 500 Futures" },
  { sym: "YM", name: "Dow Futures" },
  { sym: "GC", name: "Gold Futures" },
  { sym: "CL", name: "Crude Oil" },
  { sym: "BTC", name: "Bitcoin" },
  { sym: "ETH", name: "Ethereum" },
  { sym: "EURUSD", name: "EUR / USD" },
  { sym: "GBPUSD", name: "GBP / USD" },
  { sym: "GBPJPY", name: "GBP / JPY" },
  ...("USDJPY USDCHF AUDUSD USDCAD NZDUSD EURGBP EURJPY EURCHF EURAUD EURCAD EURNZD GBPCHF GBPAUD GBPCAD GBPNZD " +
    "AUDJPY AUDCHF AUDCAD AUDNZD CADJPY CADCHF CHFJPY NZDJPY NZDCHF NZDCAD").split(" ").map((p) => ({ sym: p, name: `${p.slice(0, 3)} / ${p.slice(3)}` })),
  { sym: "AAPL", name: "Apple" },
  { sym: "TSLA", name: "Tesla" },
  { sym: "NVDA", name: "Nvidia" },
];

export const TIMEFRAMES = ["1m", "5m", "15m", "1h"];

export const SCORE_FACTORS = [
  "Trend Alignment",
  "VWAP Position",
  "Momentum (RSI)",
  "Volume Surge",
  "Fair Value Gap",
  "Liquidity Sweep",
  "Market Structure",
];

export const hasAccess = (u) => !!(u && u.has_access);
